const shippingElement = document.querySelector('.shipping_info');
const price = document.querySelector('.price-list .price');
const priceText = price.textContent.match(/\d+/)[0];
const title = document.querySelector('.product-meta__title.heading.h1').innerHTML

if (priceText <= 1) {
shippingElement.innerHTML = "inkl. MwSt. zzgl. 5€ Versand";
} else if (priceText < 5) {
shippingElement.innerHTML = "inkl. MwSt. zzgl. 1€ Versand";
} else if (priceText >= 5 && priceText < 10) {
shippingElement.innerHTML = "inkl. MwSt. zzgl. 2€ Versand";
} else if (priceText >= 10 && priceText < 125 ) {
shippingElement.innerHTML = "inkl. MwSt. zzgl. 5€ Versand";
} else if (priceText >= 125) {
shippingElement.innerHTML = "inkl. MwSt. kostenloser Versand";
}

if (title === "Xiaomi Mi MDY-11-EZ Charger 33W Netzteil (ohne Kabel)") {
  shippingElement.innerHTML = "inkl. MwSt. zzgl. 5€ Versand";
}